<hlm-alert-dialog>
  <hlm-alert-dialog-content *brnAlertDialogContent class="p-6 max-w-2xl">
    <div class="flex flex-col gap-4">
      <div class="flex justify-center w-full">
        <ng-icon
          hlm
          name="lucideTriangleAlert"
          size="xl"
          class="text-amber-500"
        />
      </div>

      <div class="flex flex-col gap-2 text-center">
        <h3 class="text-lg font-semibold">
          Il modello {{ templateTypeLabel() }} è incompleto
        </h3>
        <p class="text-sm text-muted-foreground">
          Il file caricato è valido, ma {{ missingCountPhrase() }} dal modello
          esempio. I dati corrispondenti
          <strong>non appariranno</strong> nei documenti esportati.
        </p>
      </div>

      <div
        class="flex flex-col gap-2 max-h-72 overflow-y-auto border rounded-md p-3"
      >
        @for (item of missingPlaceholders(); track item.key) {
          <div
            class="flex items-start gap-3 p-2 border-b last:border-b-0 border-border"
          >
            <div class="flex flex-col gap-0.5 flex-1 min-w-0">
              <code
                class="text-xs bg-muted px-1.5 py-0.5 rounded font-mono w-fit"
              >
                {{ "{" + item.key + "}" }}
              </code>
              <p class="text-xs text-muted-foreground">{{ item.description }}</p>
            </div>
          </div>
        }
      </div>

      <div class="text-sm text-muted-foreground bg-muted/50 p-3 rounded-md">
        <strong class="text-foreground">Cosa fare?</strong> Se vuoi includere
        questi dati, torna in Word, riapri il modello esempio per copiare i
        segnaposto mancanti, poi ricarica il file. Altrimenti puoi caricare
        comunque il modello così com'è.
      </div>

      <div class="flex flex-col sm:flex-row gap-2 sm:justify-end">
        <button type="button" hlmAlertDialogCancel (click)="onCancel()">
          Annulla
        </button>
        <button type="button" hlmBtn variant="default" (click)="onConfirm()">
          Carica comunque
        </button>
      </div>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
